module.exports = __webpack_public_path__ + "static/media/doc.faf0f3fb.svg";